'use client';

import { openCookiePreferences } from '@cmp/Utils/OpenCookiePreferences';
import Button from '@gds/Button/Button';

import type { CtaElementProperties } from './Cta.entity';

type CookiePreferencesCtaProps = Pick<
  CtaElementProperties,
  'ctaText' | 'color' | 'variant' | 'darkMode'
> & {
  fullWidth?: boolean;
};

export const CookiePreferencesCta = ({
  ctaText,
  color,
  variant,
  darkMode,
  fullWidth,
}: CookiePreferencesCtaProps) => (
  <Button
    type="button"
    onClick={openCookiePreferences}
    darkMode={darkMode}
    {...(color && { color })}
    {...(variant && { variant })}
    {...(fullWidth !== undefined && { fullWidth })}
  >
    {ctaText}
  </Button>
);
